import React from 'react';
import { Typography } from 'antd';

interface DisclaimerProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

export const disclaimerStyle: React.CSSProperties = {
  padding: 5,
  fontWeight: 230,
  fontSize: 12,
  lineHeight: '27px',
  fontFamily: 'Open Sans, sans-serif',
  color: '#4a4a4a',
  display: 'flex',
  alignItems: 'center',
  letterSpacing: '0.03em',
};

export const Disclaimer: React.FC<DisclaimerProps> = ({ children, style }) => {
  return (
    <Typography.Title level={3} style={{ ...disclaimerStyle, ...style }}>
      {children}
    </Typography.Title>
  );
};
